import "./style.css";
import { useState } from 'react';
import SimpleBarChart from "components/Common/Charts/SimpleBarChart";
import QuickTimeRange from "components/Common/DateRangeComponents/QuickTimeRange";
import { Card, Col, Row,} from "antd";
import { vehicleTopAndLeastRunningApiUrl } from "components/Common/endpoints";
import { useFetchLive } from 'hooks/useFetchLive';
import { getQuickTimeRange } from 'components/Common/DateTimeUtils';
import { ROUTES } from "components/Common/Constants";
import NoData from "components/Common/NoData";

const LeaderBoard = () => {
  const [timeRange, setTimeRange] = useState(getQuickTimeRange('obj', 'thisMonth'));
  const { data } = useFetchLive(
    vehicleTopAndLeastRunningApiUrl, 
    timeRange,
  );

  const onTimeFilterChange = (value) => {
    setTimeRange(getQuickTimeRange('obj', value));
  }

  return(
          <Card
            bordered={false}
            className="distance-graphs"
            title={
              <Row className="distance-card-title">
                <Col span="8"><span>Leader Board</span></Col>
                <Col span="16">
                  <div>
                    <QuickTimeRange
                      onTimeFilterChange={onTimeFilterChange}
                      showText={true}
                    />
                  </div>
                </Col>
              </Row>
            } 
          >
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={24} id="top-running" className="distance-graph-frame">
                    {data?.topRunning?.length > 0 ?
                      <SimpleBarChart 
                        title="Top 10 Running Vehicles"
                        key="top"
                        data={data?.topRunning}
                        legendName="Distance"
                        seriesColor="#20bd41"
                        fieldDetails={{nameField: 'imei', valueField: 'distance', units: ''}}
                        chartHeight={210}
                        toolTipUrl={ROUTES.VEHICLE_ANALYTICS.link}
                      />
                      :
                      <NoData/>
                    }
                  </Col>
                </Row>
                <Row>
                  <Col span={24} id="least-running" className="distance-graph-frame">
                    {data?.leastRunning?.length > 0 ?
                      <SimpleBarChart 
                        title="Least 10 Running Vehicles"
                        key="least"
                        data={data?.leastRunning}
                        legendName="Distance"
                        seriesColor="#20bd41"
                        fieldDetails={{nameField: 'imei', valueField: 'distance', units: ''}}
                        chartHeight={210}
                        toolTipUrl={ROUTES.VEHICLE_ANALYTICS.link}
                      />
                      :
                      <NoData/>
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
  )
};

export default LeaderBoard;